export enum NotificationCategory {
    DOCUMENT_PROCESSING = 'Document Processing',
    CONTENT_SHARING = 'Content Sharing',
    ASSISTANT_UPDATES = 'Assistant Updates',
    WORKSPACE_CHANGES = 'Workspace Changes',
    CONNECTOR_SYNC_STATUS = 'Connector Sync Status',
    SYSTEM_ANNOUNCEMENTS = 'System Announcements',
    WORKFLOW_EVENTS = 'Workflow Events',
    TENANT_LIFECYCLE = 'Tenant Lifecycle',
    SUBSCRIPTION_BILLING = 'Subscription and Billing',
    DOC_ANALYST = 'Doc Analyst',
    USER_ROLES = 'User and Roles',
}